import {
    GET_POS_ENTRY_MODE,
    GET_POS_ENTRY_MODE_SUCCESS,
    UPDATE_POS_ENTRY_MODE,
    UPDATE_POS_ENTRY_MODE_SUCCESS,
    POS_ENTRY_MODE_API_ERROR,
  } from "./actionTypes";
  
  export const getPosEntryModeList = () => ({
    type: GET_POS_ENTRY_MODE,
  });
  
  export const getPosEntryModeListSuccess = record => ({
    type: GET_POS_ENTRY_MODE_SUCCESS,
    payload: record,
  });
  
  export const updatePosEntryMode = record => ({
    type: UPDATE_POS_ENTRY_MODE,
    payload: record,
  });
  
  export const updatePosEntryModeSuccess = record => ({
    type: UPDATE_POS_ENTRY_MODE_SUCCESS,
    payload: record,
  });
  
  export const apiPosEntryModeApiError = error => {
    return {
      type: POS_ENTRY_MODE_API_ERROR,
      payload: error,
    };
  };
  